import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {translate} from 'react-i18next';
import classNames from 'classnames';
import ErrorForm from '../../App/ErrorForm';
import * as _ from 'lodash';
import ReactPasswordStrength from 'react-password-strength';


class PasswordView extends Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.hasError = this.hasError.bind(this);
    this.passwordCallback = this.passwordCallback.bind(this);
    this.state = {
      password: '',
      confirmPassword: '',
      currentPassword: ''
    };

    this.passwordRef = React.createRef();
  }

  hasError(key) {
    const {errors} = this.props;
    return errors.error && _.includes(errors.error, key);
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (nextProps.flash && nextProps.flash.type === 'success') {
      return {
        password: '',
        confirmPassword: '',
        currentPassword: ''
      }
    }
    return state;
  }

  componentDidUpdate() {
    if (this.props.flash && this.props.flash.type === 'success') {
      this.passwordRef.current.clear();
    }
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    const {closeFlash, clearError} = this.props;
    this.setState({
      [name]: value
    });
    if (closeFlash) {
      closeFlash();
    }
    if (clearError) {
      clearError();
    }
  }

  passwordCallback(data) {
    const {closeFlash, clearError} = this.props;
    if (data.password !== '') {
      if (closeFlash) {
        closeFlash();
      }
      if (clearError) {
        clearError();
      }
      this.setState({
        password: data.password
      });
    }
  }

  getDataUser() {
    let {password, currentPassword, confirmPassword} = this.state;
    const {profile} = this.props;
    return {
      ...profile,
      password: password,
      current_password: currentPassword,
      confirmPassword: confirmPassword,
    };
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.action({
      ...this.getDataUser(),
    });
  }

  render() {
    let {password, currentPassword, confirmPassword} = this.state;
    const {t, inProgress, current, errors} = this.props;
    return (
        <form onSubmit={this.handleSubmit}>
          {current &&
          <div className="form__row">
            <label className="form__label">{t('current_password')}</label>
            <input
              name='currentPassword'
              type="password"
              placeholder={t('current_password')}
              className={
                classNames('input input--block', {
                  'input--invalid': this.hasError('current_wrong'),
                })
              }
              value={currentPassword}
              onChange={this.handleChange}
            />
          </div>
          }
          <div className='form__row'>
            <label className="form__label">{t('new_password')}</label>
            <ReactPasswordStrength
              ref={this.passwordRef}
              className='input input--block'
              minLength={6}
              minScore={2}
              scoreWords={[]}
              tooShortWord={''}
              changeCallback={this.passwordCallback}
              inputProps={{ name: "password", autoComplete: "off", placeholder: t('new_password'), value: {password},
                className: classNames({'input--invalid': this.hasError('password_length')})
              }}
            />
          </div>
          <div className="form__row">
            <label className="form__label">{t('confirm_password')}</label>
            <input
              name='confirmPassword'
              type="password"
              placeholder={t('confirm_password')}
              className={
                classNames('input input--block', {
                  'input--invalid': this.hasError('confirm_password_length') || this.hasError('wrong_confirm_password'),
                })
              }
              value={confirmPassword}
              onChange={this.handleChange}
            />
          </div>
          <ErrorForm
            errors={errors.error || []}
          />
          <div className="form__row">
            <div className='profile__one-buttons'>
              <button
                className="form__button"
                type="submit"
                disabled={!password || inProgress}>
                {t('change')}
              </button>
            </div>
          </div>
        </form>
    );
  }
}

PasswordView.propTypes = {
  profile: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
  errors: PropTypes.object,
  inProgress: PropTypes.bool,
  current: PropTypes.bool,
  closeFlash: PropTypes.func
};

export default translate('translations')(PasswordView);



// WEBPACK FOOTER //
// ./src/components/Customer/Profile/PasswordView.js